import React from 'react'
import { TooltipCP } from 'submodules/nerit-framework-ui/common/components/tooltip/TooltipCP'
import { FieldRegulationConditionTP } from 'submodules/nerit-aquatec-sdk/services/regulation/types/FieldRegulationConditionTP'
import { RegulationConditionUtils } from 'modules/fields/utils/RegulationConditionUtils'

interface ICPProps {
    referenceName: string
    conditions: FieldRegulationConditionTP[]
}

/**
 * "Condicional (pH)" com as faixas no tooltip, uma por linha, na ordem salva.
 */
export function ConditionalLimitLabelCP(props: ICPProps): JSX.Element {

    return (
        <TooltipCP
            showSpan={true}
            text={RegulationConditionUtils.legendLines(props.conditions, props.referenceName).map(line => <div key={line}>{line}</div>)}
        >
            {RegulationConditionUtils.conditionalLabel(props.referenceName)}
        </TooltipCP>
    )
}
